<template>
    <div class="results-list">
        <div class="screening">
            <el-row>
                <el-col :span="8">
                    <el-dropdown trigger="click" @command="xzqChange">
                      <span class="el-dropdown-link">
                          <span>{{this.selectXzq.label}}</span>
                          <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                        <el-dropdown-menu slot="dropdown">
                           <el-dropdown-item v-for="(item,index) in xzqArray" v-text="item.label" :command="item" :key="'header'+ index">
                           </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
               <!--  <el-col :span="8">
                    <el-dropdown trigger="click">
                         <span class="el-dropdown-link">
                            <span>用地性质</span>
                             <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>全部</el-dropdown-item>
                            <el-dropdown-item>工业用地</el-dropdown-item>
                            <el-dropdown-item>商业用地</el-dropdown-item>
                            <el-dropdown-item>住宅用地</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col> -->
                <el-col :span="8">
                    <el-dropdown trigger="click"  @command="mjfwChange">
                         <span class="el-dropdown-link">
                            <span>{{this.selectMjfw.name}}</span>
                             <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                           <el-dropdown-item v-for="(item,index) in mjfwArray" v-text="item.name" :command="item" :key="'header'+ index">
                           </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </div>
        <div class="results">
            <div class="results-list">
                <el-scrollbar style="height: 100%;width: 100%;">
                    <el-empty v-show="totalCount===0" :image-size="200"></el-empty>
                    <ul>
                        <li :class="resultActive === index? 'active': ''" @click="resultsDetails(item,index)" v-for="(item, index) in list" :key="'list'+index"
                          @mouseover="mousemoveHandler(index,true)" @mouseout="mousemoveHandler(index,false)">
                            <el-row>
                                <el-col class="result-index" :span="3">
                                    <i class="iconfont icon-dingweiqipao-"></i>
                                    <span v-html="index+1"></span>
                                </el-col>
                                <el-col class="result-information" :span="14">
                                    <div class="title" :title="item.properties.dkmc" v-html="item.properties.dkmc">{{item.dkmc}}</div>
                                    <div class="location">
                                        <i class="iconfont icon-dingwei"></i>
                                        <span :title="item.properties.dkdz" v-html="item.properties.dkdz"></span>
                                    </div>
                                    <div class="area">
                                        <i class="iconfont icon-mianji"></i>
                                        <span>面积：<span class="num" v-html="item.properties.dkmj"></span>亩</span>
                                    </div>
                                </el-col>
                                <el-col class="result-img" :span="7">
                                    <div v-if="!item.properties.qjt||item.properties===''" class="no-data">
                                        <i class="iconfont icon-zanwutupian"></i>
                                    </div>
                                     <el-image  style="width: 100%; height: 100%" v-if="item.properties.qjt&&item.properties!==''"
                                      :src="baseServer+item.properties.qjtthumbnail"  fit="cover">
                                       <div slot="placeholder" class="image-slot">
                                          加载中<span class="dot">...</span>
                                        </div>
                                      </el-image>
                                  <!--   <img v-if="item.properties.qjt&&item.properties!==''"
                                      :src="baseServer+item.properties.qjt" alt=""/> -->
                                </el-col>
                            </el-row>
                       </li>
                    </ul>
                </el-scrollbar>
            </div>
            <div class="results-pagination clearfix">
                <div class="results-total">
                    共 {{totalCount}} 个地块
                </div>
                <div class="pagination">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            background
                            :pager-count="5"
                            layout="prev, pager, next"
                            :total="totalCount">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '@/components/common/bus'
import util from '@/js/util'
import {mapmanager, LAND_TYPE, xzqUtils} from '@/views/class/mapmanager'
import { mapResourceApi } from '@/api/mapResourceApi'
import vimportmap from 'components/main-map/import-map'

export default {
  components: {
    vimportmap
  },
  data() {
    return {
      map: null,
      xzqArray: xzqUtils.xzqArray,
      selectXzq: {
        label: '行政区',
        code: '0'
      },
      selectMjfw: {
        name: '面积范围',
        code: '0'
      },
      mjfwArray: [{
        name: '全部',
        code: '0'
      }, {
        name: '0-50亩',
        code: '0-50'
      }, {
        name: '50-100亩',
        code: '50-100'
      }, {
        name: '100-200亩',
        code: '100-200'
      }, {
        name: '200-500亩',
        code: '200-500'
      }, {
        name: '500亩以上',
        code: '500'
      }],
      list: [],
      sysInitDataArray: [],
      queryResultArray: [],
      markerIsSelected: false,
      totalCount: 0,
      centerIndex: 0,
      resultActive: '',
      currentPage: 1,
      baseServer: ''
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.initXZQ()
    this.baseServer = `${gisserverUrl}`
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    const _this = this
    // todo
    bus.$on('goback', msg => {
      this.resultActive = -1
      this.markerIsSelected = false
    })
    bus.$on('initListData', msg => {
      _this.sysInitDataArray = msg
    })
    bus.$on('markmouseover', index => {
      this.resultActive = index - 1
    })
    bus.$on('mouseout', index => {
      if (this.markerIsSelected === false) {
        this.resultActive = -1
      }
    })
    bus.$on('resultMarkclick', feature => {
      this.markerIsSelected = true
      this.$parent.componentShow = 'mapSearchResultsList'
      this.resultsDetails(feature, feature.index - 1)
    })
  },
  methods: {
    initXZQ() {
      const param = {}
      let cantoncity = '株洲市'
      for (let i = 0; i < city.length; i++) {
        if (city[i].check === true) {
          cantoncity = city[i].cityname
        }
      }
      param.cantoncity = cantoncity
      mapResourceApi.selectByCityName(param).then(res => {
        if (res.code === '200') {
          localStorage.setItem('xzqUtil_datas', JSON.stringify(res.data))
          if (res.data.length > 0) {
            const txzqArray = [{
              label: '全部',
              value: '0'
            }]
            for (let i = 0; i < res.data.length; i++) {
              const datas = []
              datas.label = res.data[i].cantonname
              datas.value = res.data[i].cantoncode
              txzqArray.push(datas)
            }
            this.xzqArray = txzqArray
          }
        }
      })
    },
    initResultList(queryWord, ydxz) {
      mapmanager.setlandMarkerTooptip(false)
      this.queryWord = queryWord
      this.ydxz = ydxz
      this.selectXzq = {
        name: '行政区',
        value: '0'
      }
      this.selectMjfw = {
        name: '面积范围',
        code: '0'
      }
      this.resultListHandler(queryWord, ydxz)
    },
    resultListHandler(queryWord, ydxz) {
      const _this = this
      if (queryWord === '' || queryWord === ' ') {
        this.queryResultArray = this.sysInitDataArray
      } else {
        this.queryResultArray = this.sysInitDataArray.filter((value, index, array) => value.properties.dkmc.indexOf(queryWord) > -1 || value.properties.dkdz.indexOf(queryWord) > -1)
      }
      if (ydxz !== LAND_TYPE.land_type_suoyou) {
        this.queryResultArray = this.queryResultArray.filter((value, index, array) => Number(value.properties.ydxz) === ydxz)
      }
      if (this.selectXzq.value !== '0') {
        this.queryResultArray = this.queryResultArray.filter((value, index, array) => value.properties.xzq === this.selectXzq.value)
      } else {
        this.selectXzq = {
          label: '行政区',
          value: '0'
        }
      }
      if (this.selectMjfw.code !== '0') {
        this.queryResultArray = this.queryResultArray.filter((value, index, array) => {
          if (_this.selectMjfw.code === '500') {
            return Number(value.properties.dkmj) > 500
          } else {
            const xzmj = _this.selectMjfw.code.split('-')
            return Number(value.properties.dkmj) > Number(xzmj[0]) && Number(value.properties.dkmj) < Number(xzmj[1])
          }
        })
      } else {
        this.selectMjfw = {
          name: '面积范围',
          code: '0'
        }
      }
      this.totalCount = this.queryResultArray.length
      if (this.queryResultArray.length === 0) {
        this.list = []
        util.info('没有查询到数据...')
        mapmanager.setlandMarkerTooptip(true)
        return
      }
      this.handleCurrentChange(1)
    },
    resultsDetails(item, index) {
      this.$parent.componentShow = 'mapDetails'
      // this.$parent.$parent.$refs.search.keyWord = item.title
      this.$parent.resultsDetails(item, false)
      setTimeout(() => {
        mapmanager.markerSelectedHandler(index + 1, true)
      }, 60)
    },

    xzqChange(command) {
      // let resultArray = this.queryResultArray
      debugger
      this.selectXzq = command
      this.resultListHandler(this.queryWord, this.ydxz)
    },
    mjfwChange(command) {
      this.selectMjfw = command
      this.resultListHandler(this.queryWord, this.ydxz)
    },
    handleSizeChange() {
      //
    },
    handleCurrentChange(val) {
      this.currentPage = val
      const startIndex = (val - 1) * 10
      let endIndex = val * 10
      if (endIndex > this.totalCount) {
        endIndex = this.totalCount
      }
      const list = []
      let index = 0
      for (let i = 0; i < this.queryResultArray.length; i++) {
        const element = this.queryResultArray[i]
        const dkmj = (element.properties.dkmj * 0.0015).toFixed(2)
        element.properties.dkmj_mu = dkmj
        // 处理全景图缩略图
        if (element.properties.qjt) {
          const qjt = element.properties.qjt
          const index = qjt.lastIndexOf('/')
          const path = qjt.substring(0, index)
          const filename = qjt.substring(index, qjt.length)
          const qjtthumbnail = path + '/thumbnail' + filename
          element.properties.qjtthumbnail = qjtthumbnail
        }
        if (i >= startIndex && i < endIndex) {
          index++
          element.index = index
          list.push(element)
        } else {
          element.index = 0
        }
      }
      this.list = list
      if (this.list.length > 0) {
        this.drawQueryResultGeojson(this.list)
      }
    },
    drawQueryResultGeojson(queryResultArray) {
      mapmanager.drawQueryResultGeojson(queryResultArray)
    },
    mousemoveHandler(index, status) {
      mapmanager.markerMousemoveHandler(index + 1, status)
    }
  }
}
</script>
<style lang="scss" scoped>
    .results-list{
        height: 100%;
        width: 100%;
        .screening{
            border-bottom: 1px solid #dfdfdf;
            ::v-deep{
                .el-dropdown {
                    color: #333;
                    height: 44px;
                    background: #ffffff;
                    font-size: 14px;
                    .el-dropdown-link{
                        line-height: 44px;
                        cursor: pointer;
                    }
                }
            }
        }
        .results{
            height: calc(100% - 44px);
            .results-list{
                height: calc(100% - 50px);
                li{
                    border-bottom: 1px solid #dfdfdf;
                    padding: 10px;
                    text-align: left;
                    cursor: pointer;
                    .result-index{
                        text-align: center;
                        position: relative;
                        .iconfont{
                            color: #F54236;
                            font-size: 40px;
                        }
                        span{
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            font-size: 14px;
                            color: #ffffff;
                            margin-top: 5px;
                        }
                    }
                    .result-information{
                        font-size: 14px;
                        color: #999999;
                        .title{
                            font-size: 14px;
                            font-weight: bold;
                            color: #333333;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                            width: 100%;
                            margin-bottom: 10px;
                        }
                        .location{
                            margin-bottom: 7px;
                        }
                        .area{
                            .num{
                                color: #CC0101;
                            }
                        }
                        .iconfont{
                            font-size: 14px;
                            margin-right: 5px;
                        }
                    }
                    .result-img{
                        padding-left: 10px;
                        height: 74px;
                        .no-data{
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #F2F5F6;
                            border-radius: 4px;
                            i.iconfont{
                                color: #D0DCE5;
                                font-size: 44px;
                                text-align: center;
                            }
                        }
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    &:hover,&.active{
                        background: #f1f1f1;
                        .result-index {
                            .iconfont {
                                color: #4293F4;
                            }
                        }
                    }
                }
                ::v-deep{
                    .el-scrollbar__wrap{
                        overflow-x: hidden;
                    }
                }
            }
            .results-pagination{
                height: 50px;
                padding-top: 12px;
                padding-left: 10px;
                .results-total{
                    float: left;
                    line-height: 26px;
                    color: #666666;
                }
                .pagination{
                    float: right;
                }
            }
        }
    }
</style>
